import axios from 'axios';

const instance = axios.create();
const v3Instance = axios.create();
const v4Instance = axios.create();
// const ssoInstance = axios.create();

// instance.defaults.baseURL = "https://api-mdl.mfu.ac.th/api/v1";
// instance.defaults.baseURL = "https://localhost:8000/api/v1";
// instance.defaults.baseURL = "https://202.151.188.124:443/api/v1";
//instance.defaults.baseURL = "https://10.3.2.89/api/v1";

const apiBaseUrl = process.env.VUE_APP_API_BASE_URL || 'http://localhost:8000';

instance.defaults.baseURL = `${apiBaseUrl}/api/v1`;
v3Instance.defaults.baseURL = `${apiBaseUrl}/api/v3`;
v4Instance.defaults.baseURL = `${apiBaseUrl}/api/v4`;

instance.defaults.timeout = 86400000;

instance.defaults.headers = {
  'Access-Control-Allow-Origin': '*',

  //cloudn production
  // "Access-Control-Allow-Origin": "https://mdl.mfu.ac.th/",
  'Content-Type': 'application/json',
};

export default {
  onSetToken() {
    instance.defaults.headers = {
      'Content-Type': 'application/json',
      Authorization: `Basic ${localStorage.getItem('token')}`,
      x_access_token: localStorage.getItem('token'),
    };
  },

  onSetTokenv3() {
    v3Instance.defaults.headers = {
      'Content-Type': 'application/json',
      Authorization: `Basic ${localStorage.getItem('token')}`,
      x_access_token: localStorage.getItem('token'),
    };
  },
  onSetTokenv4() {
    v4Instance.defaults.headers = {
      'Content-Type': 'application/json',
      Authorization: `Basic ${localStorage.getItem('token')}`,
      x_access_token: localStorage.getItem('token'),
    };
  },

  //mfuREG
  regEnrollCourse(body) {
    this.onSetToken();
    return instance.get('mfureg/enroll-course');
  },
  regEnrollCourseSingle(body) {
    const courseId = { courseId: body };
    this.onSetToken();
    return instance.get('mfu/enroll-course', courseId);
  },
  //=============
  onGetNotice() {
    this.onSetToken();
    return instance.get('notify/user');
  },
  onMarkNotice(body) {
    this.onSetToken();
    return instance.put('notify/user/read', body);
  },

  onGoogleLogin(body) {
    return instance.post('/googleLogin', body);
  },
  onGoogleLoginSecondPath(body) {
    return instance.post('/createGoogleUser', body);
  },
  onFacebookLogin(body) {
    return instance.post('/facebook-login', body);
  },
  onFacebookLoginSecondPath(body) {
    return instance.post('/facebook-create', body);
  },

  onVerifyLogin(body) {
    return instance.put('/verify', body);
  },

  onForgotPassword(body) {
    return instance.post('/forgotpassword', body);
  },

  onResetPassword(body) {
    return instance.put('/resetpassword', body);
  },

  onGetProfile(body) {
    return instance.get('/profile', body);
  },

  onVerifyForgot(body) {
    return instance.put('/verify', body);
  },
  fetchCourseQuizPermissionAPI(body) {
    this.onSetToken();
    return instance.post('/template/prepare/data', body);
  },
  onVerifySignup(body) {
    return instance.put('/verify', body);
  },

  onSignup(body) {
    return instance.post('/register', body);
  },

  fetchCourses() {
    return instance.get('/course/home/all');
  },
  fetchCoursePage(courseCode) {
    this.onSetToken();
    return instance.get('/course/page/' + courseCode);
  },
  fetchAllCourses() {
    return instance.get('/courses');
  },
  fetchCourseTopic(courseCode) {
    return instance.get('/course/topic/' + courseCode);
  },
  getComment(courseId) {
    return instance.get('/comment/' + courseId);
  },
  setComment(body) {
    return instance.post('/comment/createComment/', body);
  },
  fetchCoursesOverview(courseId) {
    return instance.post('/course', courseId);
  },
  fetchCoursesOverviewLogin(coursePayload) {
    this.onSetToken();
    return instance.post('/course', coursePayload);
  },
  fetchSingleCourse(code) {
    return instance.get(`/course/${code}`);
  },
  fetchUserDataAPI() {
    this.onSetToken();
    return instance.get('/profile');
  },
  onUpdateProfileInfomation(body) {
    this.onSetToken();
    return instance.put('/profile', body);
  },
  onUpdatePhoneProfile(body) {
    this.onSetToken();
    return instance.put('/profile/phone', body);
  },
  onUpdateDisplaynameProfile(body) {
    this.onSetToken();
    return instance.put('/profile/displayname', body);
  },
  onUpdateProfileImage(body) {
    this.onSetToken();
    return instance.put('/profile/image', body);
  },
  addFavouriteCourse(body) {
    this.onSetToken();
    let courseId = {
      courseId: body.course_id,
    };
    let _id = body.user_id;
    return instance.put('/course/profile/favourite/add?_id=' + _id, courseId);
  },
  deleteFavouriteCourse(body) {
    let courseId = {
      courseId: body.course_id,
    };
    let _id = body.user_id;
    this.onSetToken();
    return instance.put(
      '/course/profile/favourite/delete?_id=' + _id,
      courseId
    );
  },
  onUpdateUsername(body) {
    this.onSetToken();
    return instance.put('/changeUsername', body);
  },
  onSendOTP(body) {
    return instance.post('/sendotp', body);
  },
  onChangePassword(body) {
    return instance.put('/changePassword', body);
  },
  fetchTemplate(body) {
    let obj = {
      code: body,
    };
    return instance.post('/template/v2', obj);
  },

  /// CPR ///
  fetchContent(body) {
    this.onSetToken();
    return instance.post('/getTemplate', body);
  },
  getIntructorCourseAPI(body) {
    this.onSetToken();
    return instance.post('/teacher/courses', body);
  },
  getCourseDetailAPI(body) {
    this.onSetToken();
    return instance.post('/teacher/course/details', body);
  },
  fetchProgress(body) {
    let params = body.courseId;
    return instance.get('/progress/user/getcourse/' + params);
  },
  saveProgress(body) {
    let params = body.courseId;
    return instance.put('/progress/user/addcourse', body);
  },
  setCourseTopicProgress(body) {
    let param = body.topicId;
    return instance.put('/course/chapter/topic/' + param, body);
  },
  getCourseChapterAndProgress(params) {
    this.onSetToken();
    return instance.get('/course/progress/' + params);
  },
  getCourseAndProgressHomePage(params) {
    this.onSetToken();
    return instance.get('/course/home-card/progress/' + params);
  },
  getProgressMenu(payload) {
    let body = {
      section: payload.section,
    };
    this.onSetToken();
    return instance.post(
      'course/menu-content/progress/' + payload.courseId,
      body
    );
  },
  getProgressChapter(object) {
    this.onSetToken();
    return instance.post(
      'course/chapter-content/progress/' + object.parameters,
      {
        templateCode: object.templateCode,
        section: object.section,
      }
    );
  },
  onUpdateTopicProgress(body) {
    return instance.post('/course/topic/progress/' + body.topicId, body);
  },
  createUserTemplate(body) {
    return instance.put('/content/user-insert', body);
  },
  saveUserTemplate(body) {
    this.onSetToken();
    return instance.put('/content/user-update', body);
  },
  getCourseProgress(params) {
    return instance.get('/course/progress/chapter/' + params);
  },
  getLockTest(body) {
    this.onSetToken();
    return instance.post('/admin/lock-test/display', body);
  },
  updateQuizStatus(body) {
    this.onSetToken();
    return instance.put('/admin/lock-test/update', body);
  },
  getBanner() {
    return instance.get('/banners');
  },
  getDataExport(body) {
    this.onSetToken();
    return instance.post('/coures/progress/section', body);
  },
  getDataExportChinese2(body) {
    return instance.post('/chn2/query/export/section/user-score', body);
  },
  getPrepostStatus(body) {
    this.onSetToken();
    return instance.post('/course/pre-post/score', body);
  },
  addCourseViewer(body) {
    return instance.put('/course/add-array', body);
  },
  getAssignmentTest(body) {
    this.onSetToken();
    return instance.post('/course/quiz/topic/score', body);
  },
  setCompleteCourse(body) {
    this.onSetToken();
    return instance.put('/course/complete', body);
  },
  getHistoryTemplate() {
    this.onSetToken();
    return instance.post('/template/profile/codeTemplate');
  },
  getScore(body) {
    this.onSetToken();
    return instance.post('/content/total-score', body);
  },
  getAllContent(body) {
    return instance.get('/getContent/' + body);
  },
  getCompletePostTest(body) {
    this.onSetToken();
    var course = {
      courseId: body.code,
    };
    return instance.post('/getComplete-PostTest', course);
  },
  getTestTemplate(body) {
    return instance.post('/excel/template/test-query', body);
  },
  getTemplateAndProgress(body) {
    this.onSetToken();
    return instance.post('/chn2/query/template', body);
  },
  getLessonAndProgress(body) {
    this.onSetToken();
    return instance.post('/chn2/menu/select', body);
  },
  commitUserProgress(body) {
    this.onSetToken();
    return instance.put('/chn2/update/content/add-user', body);
  },
  getFlipCardChinese2(body) {
    return instance.post('/chn2/query/vocabulary/flipcard', body);
  },
  getSheetResultChinese2(body) {
    this.onSetToken();
    return instance.post('/chn2/query/note/image', body);
  },
  checkTestOpen(body) {
    this.onSetToken();
    return instance.post('/chn2/menu-lock/test', body);
  },

  //v3
  ///get template
  v3GetTemplateByContent(data) {
    return v3Instance.get('/templates', { params: { content: data } });
  },
  v3GetTemplateByCode(data) {
    return v3Instance.get('/templates', { params: { codeItem: data } });
  },
  ///get course progress
  v3GetCourseProgress(data) {
    this.onSetTokenv3();
    return v3Instance.get('/progress', {
      params: { codeItem: data.codeItem, courseId: data.courseId },
    });
  },

  ///send complete content
  v3SaveContent(data) {
    this.onSetTokenv3();
    return v3Instance.post('/save-content', { data: data });
  },

  ///send Score and Progress
  v3SaveScoreAndProgress(data) {
    this.onSetTokenv3();
    return v3Instance.post('/save-score', { data: data });
  },
  //send chapter progress
  v3SaveChapterProgress(data) {
    this.onSetTokenv3();
    return v3Instance.post('/save-progress', { data: data });
  },

  //// enroll course in overview page
  v3CourseEnroll(data) {
    this.onSetTokenv3();
    return v3Instance.post('/enroll', data);
  },
  v3IsEnroll(data) {
    this.onSetTokenv3();
    return v3Instance.get('/enroll', { params: { courseId: data.courseId } });
  },
  v3IsTeaching() {
    this.onSetTokenv3();
    return v3Instance.get('/teaching');
  },
  v3TeacherCourseDetails(data) {
    this.onSetTokenv3();
    return v3Instance.get('/teaching-details', {
      params: { courseId: data.courseId, section: data.section },
    });
  },
  v3TeacherExport(data) {
    this.onSetTokenv3();
    return v3Instance.get('/teaching-course-export', {
      params: { courseId: data.courseId, section: data.section },
    });
  },
  v3TeacherLessonLock(data) {
    this.onSetTokenv3();
    return v3Instance.get('/teaching-lesson-lock', {
      params: { courseId: data.courseId, section: data.section },
    });
  },

  v3TeacherLessonLockUpdate(data) {
    this.onSetTokenv3();
    return v3Instance.post('/teaching-lesson-lock-update', { data: data });
  },

  //getParent
  v3GetParent(data) {
    return v3Instance.get('/chapter-parent', {
      params: { codeItem: data },
    });
  },
  v3LessonFlipCard(data) {
    this.onSetTokenv3();
    return v3Instance.get('/lesson-flipcard', {
      params: { courseId: data.courseId, codeItem: data.codeItem },
    });
  },

  v3LessonLock(data) {
    return v3Instance.get('/lesson-lock-test', {
      params: { courseId: data.courseId, section: data.section },
    });
  },

  v3LessonLockStatus(data) {
    return v3Instance.get('/lesson-lock-status', {
      params: {
        courseId: data.courseId,
        section: data.section,
        codeItem: data.codeItem,
      },
    });
  },

  v3LessonNote(data) {
    this.onSetTokenv3();
    return v3Instance.get('/lesson-note', {
      params: {
        courseId: data.courseId,
        section: data.section,
        codeItem: data.codeItem,
      },
    });
  },
  v3AdminAddSection(data) {
    this.onSetTokenv3();
    return v3Instance.post('/admin/add-section', { data: data });
  },
  v3AdminAddTeacher(data) {
    this.onSetTokenv3();
    return v3Instance.post('/admin/add-teacher', { data: data });
  },

  onLogin(body) {
    // ใช้ version ปรับปรุงของ V3
    // return instance.post('reg/login', body);
    return v3Instance.post('/login', body);
  },
  v4SaveContent(payload) {
    this.onSetTokenv4();
    return v4Instance.post('/save-content', { data: payload });
  },

  //sso login
  onSSOLogin(body) {
    return v4Instance.post('/sso-verify', body);
  },
};
